import styled from 'styled-components';
import { media } from 'designsystem/index';

const PhoneScenery = styled.div`
  top: 0;
  position: relative;
  display: flex;
  justify-content: center;
  
  ${media.desktop`
    display: block;
  `}

`;

export default PhoneScenery;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/PhoneScenery.jsx